module.exports = __webpack_public_path__ + "static/media/LHB-WHT.1d66764c.png";